import styled from 'styled-components';

// No width/height here: the component sets them as attributes from its `size`
// prop (default 90), and a CSS rule would outrank those and pin every avatar
// to one size.
export const StyledContainer = styled.svg`
  display: block;
`;
